export enum ClientsActionTypes {
  FETCH_CLIENT_USERS_REQUEST = 'client/users/FETCH_REQUEST',
  FETCH_CLIENT_USERS_SUCCESS = 'client/users/FETCH_SUCCESS',
  ADD_CLIENT_USERS_REQUEST = 'client/users/ADD_REQUEST',
  ADD_CLIENT_USERS_SUCCESS = 'client/users/ADD_SUCCESS',
  EDIT_CLIENT_USER_REQUEST = 'client/users/EDIT_REQUEST',
  EDIT_CLIENT_USER_SUCCESS = 'client/users/EDIT_SUCCESS',
}
